import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useSearchParams } from 'react-router-dom';
import PDFViewer from '../../components/PDFViewer';

const BillPdfViewer = () => {
    const [searchParams] = useSearchParams();
    const uri = searchParams.get('uri') ?? '';

    if (!uri) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 3 }}>
                <Typography variant="h6">No PDF was supplied for this bill.</Typography>
            </Box>
        );
    }

    return <PDFViewer URI={uri} />;
};

export default BillPdfViewer;